export default __webpack_public_path__ + "static/media/coffee-shops.cfe7067d.png";